import React, {useContext, useEffect, useRef, useState} from 'react';
import {func} from 'prop-types';
import {animated, useTransition} from 'react-spring';
import {REQUEST_STATUS} from '../../../constant/Application';
import {FormStepContext} from '../../common/form-step';
import Button from '../../common/button';
import Logo from '../../common/logo';
import If from '../../misc/If';

import './Submit.css';

const propTypes = {
  onSubmit : func.isRequired
}

function Submit(props) {
  const {onSubmit} = props;
  const {requestStatus, submissionErrors} = useContext(FormStepContext);
  const previousRequestStatus = useRef(null);
  const [toggle, set] = useState(false);

  useEffect(() => {
    const wasInProgress = previousRequestStatus.current === REQUEST_STATUS.IN_PROGRESS;
    const hasSucceeded = requestStatus === REQUEST_STATUS.SUCCEEDED;

    if (wasInProgress && hasSucceeded) {
      set(true);
    }

    previousRequestStatus.current = requestStatus;
  }, [requestStatus]);

  const transitions = useTransition(toggle, null, {
    from : {
      position : 'absolute',
      opacity  : 0
    },
    enter : {
      opacity : 1
    },
    leave : {
      opacity : 0
    }
  });

  return (
    <div className="submit">
      {transitions.map(({item, key, props}) => {
        if (item) {
          return (
            <animated.div key={key} style={props}>
              <div className="submit__success">
                <Logo />
                <svg className="submit__success-icon" height="13" width="16">
                  <path d="M14.293.293l1.414 1.414L5 12.414.293 7.707l1.414-1.414L5 9.586z" fill="currentColor" />
                </svg>

                <p className="submit__success-text">
                  Thank you, we'll be in touch shortly.<br/>
                  <a className="submit__link" href={window.location.origin}>{window.location.hostname}</a>
                </p>
              </div>
            </animated.div>
          );
        }

        return (
          <animated.div key={key} style={props}>
            <div className="submit__form">
              <Logo />

              <div className="submit__controls">
                <Button
                  className="form-navigation__button"
                  disabled={requestStatus === REQUEST_STATUS.IN_PROGRESS}
                  onClick={onSubmit}
                >
                  Submit
                </Button>

                <div className="form-navigation__hot-key-hint">
                  press

                  <strong className="form-navigation__hot-key-hint__em">
                    Enter {'\u21B5'}
                  </strong>
                </div>
              </div>

              <If condition={Boolean(submissionErrors)}>
                <section className="submit__errors">
                  Opps, something went wrong, please try again!
                </section>
              </If>
            </div>
          </animated.div>
        )
      })}
    </div>
  );
}

Submit.propTypes = propTypes;

export default Submit;
